export default __webpack_public_path__ + "static/media/ruby.6a11e05c.svg";